import { rankingItems } from '@/mocks/homeData';

export default function Ranking() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-xl md:text-3xl font-bold font-heading text-foreground-950">
            热度榜单
          </h2>
          <p className="mt-3 text-sm text-foreground-600">
            实时热度排行，看看今天大家都在吃什么瓜
          </p>
        </div>
        <div className="max-w-2xl mx-auto">
          {rankingItems.map((item, i) => (
            <a
              key={i}
              href="#ranking"
              className="flex items-center gap-4 p-4 rounded-xl hover:bg-background-100 transition-colors group cursor-pointer"
            >
              <div
                className={`w-9 h-9 flex items-center justify-center rounded-lg font-bold text-sm flex-shrink-0 ${
                  i < 3
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-200 text-foreground-600'
                }`}
              >
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-foreground-800 group-hover:text-primary-500 transition-colors truncate">
                  {item.title}
                </p>
              </div>
              <span className="text-xs text-foreground-500 whitespace-nowrap flex-shrink-0">
                {item.hot}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}